import { ReactNode, useContext, useEffect } from "react";
import { AppContext } from "context/appContext";
import { ROUTES } from "router";
import { TOAST_TYPE, ToastContext } from "context/toastContext";
import { useTranslation } from "react-i18next";

export interface PrivateRouteProps {
  readonly path: ROUTES;
  readonly element: ReactNode;
}

const PrivateRoute = ({ path, element }: PrivateRouteProps): ReactNode => {
  const { state } = useContext(AppContext);
  const displayToast = useContext(ToastContext);
  const { t } = useTranslation();

  useEffect(() => {
    if (!state.routes.includes(path)) {
      displayToast({
        message: t("errors.accessDeniedMessage"),
        type: TOAST_TYPE.ERROR,
      });
    }
  }, []);

  if (state.routes.includes(path)) {
    return element;
  }

  return null;
};

export default PrivateRoute;
